import type { Action } from 'redux'
import { combineReducers } from 'redux'
import { emptyArray } from 'utils'

import { SET_ERROR, SET_IS_PROD, SET_RANGES } from './constants'
import type { Range } from './types'

interface ActionWithMaintenance extends Action {
  payload: {
    isProd: boolean
    maintenanceMessage: string | null
    maintenanceTill: string | null
    maintenanceTillHidden: boolean
    maintenanceType: string | null
  }
}

const errorMessage = (state = '', { payload, type }: ActionWithMaintenance) => {
  switch (type) {
    case SET_ERROR:
      return typeof payload.maintenanceMessage === 'string' ? payload.maintenanceMessage : 'error.maintenance'
    default:
      return state
  }
}

const errorTill = (state: string | null = null, { payload, type }: ActionWithMaintenance) => {
  switch (type) {
    case SET_ERROR:
      return payload.maintenanceTillHidden ? null : payload.maintenanceTill || null
    default:
      return state
  }
}

const errorType = (state: string | null = null, { payload, type }: ActionWithMaintenance) => {
  switch (type) {
    case SET_ERROR:
      return payload.maintenanceType || null
    default:
      return state
  }
}

interface ActionWithIsProd extends Action {
  payload: boolean
}

const isProd = (state = true, { payload, type }: ActionWithIsProd) => {
  switch (type) {
    case SET_IS_PROD:
      return payload
    default:
      return state
  }
}

interface ActionWithRanges extends Action {
  payload: Range[]
}

const ranges = (state: Range[] = emptyArray, { payload, type }: ActionWithRanges) => {
  switch (type) {
    case SET_RANGES:
      return payload || emptyArray
    default:
      return state
  }
}

export default combineReducers({
  errorMessage,
  errorTill,
  errorType,
  isProd,
  ranges,
})
